import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton } from '@facet-wealth/design';

const AddItemButton = ({ onClick, label }) => {
  return (
    <FDPrimaryActionButton
      icon={'add'}
      onClick={onClick}
      label={label}
    />
  );
};

AddItemButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default AddItemButton;
